import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import ShowNameComponent from '../../Elements/ShowNameComponent';
import CurrencyService from '../../Services/CurrencyService';

export default class OnlineWebServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'ProgramDetails',
      tabLabel: 'Program Details',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: (item) => JsxHelper.YesNo(item.InteractionRequired), label: 'Is Interaction Required?' },
        { name: (item) => Array.isArray(item.ViaEmailChatBotOrOther) ? item.ViaEmailChatBotOrOther.join(', ') : (item.ViaEmailChatBotOrOther || ''), label: 'Via Email Chat Bot or Other?' },
        { name: 'ProductOrServiceInquiry', label: 'Product or Service Inquiry?' },
        { name: '-', label: 'Program Approach' },
        { name: (item) => Array.isArray(item.B2borB2c) ? item.B2borB2c.join(', ') : (item.B2borB2c || ''), label: 'B2B or B2C?' },
        { name: '-', label: 'B2B Approach' },
        { name: (item) => JsxHelper.YesNo(item.FictiosWebsiteCreationNeeded), label: 'Fictious Website Creation Needed' },
        { name: (item) => JsxHelper.YesNo(item.IsBusinessInformationRequired), label: 'Is Business Information Required' },
        { name: 'BusinessInformationDescription', label: 'If Yes, please describe' },
        { name: '-', label: 'B2C Demographics' },
        { name: 'MinAge', label: 'Minimum Age' },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: 'GenderB2c', label: 'Gender' },
        { name: 'OtherDemographicRequirements', label: 'Other Demographic Requirements' },
      ],
    },
    {
      tabName: 'Questionnaire',
      tabLabel: 'Questionnaire',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.TranslationProvided), label: 'Translation of Questionnaire Provided by Client?' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: (item) => JsxHelper.YesNo(item.GuidelinesProvided), label: 'Guidelines Provided by Client?' },
        { name: (item) => <LookupText lookupId={17} value={item.GenderCode} />, label: 'Gender' },
        { name: 'OtherQualifications', label: 'Other Demographic Requirements', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Validation',
      tabLabel: 'Validation',
      icon: 'fa-solid fa-check-circle',
      data: [
        { name: 'NumScreenshotsRequired', label: 'Number of Screen Shots Required' },
        { name: 'OtherPhotosDesc', label: 'Describe other Photographs Required', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Purchase',
      tabLabel: 'Purchase',
      icon: 'fa-solid fa-cart-shopping',
      data: [
        { name: (item) => JsxHelper.YesNo(item.PurchaseReqd), label: 'Purchase Required?' },
        { name: (item) => JsxHelper.YesNo(item.ReceiptReqd), label: 'Receipt Required?' },
        { name: (item) => <ShowNameComponent serviceFunction={CurrencyService.GetCurrencyNameById} id={item.PurchaseAmtCurId} />, label: 'Purchase Amount Currency' },
        { name: 'PurchaseAmt', label: 'Minimum Purchase Amount' },
        { name: 'MaxPurchaseAmt', label: 'Maximum Purchase Amount' },
        { name: 'PurchaseDesc', label: 'Item Required to Be Purchased', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReimbursed), label: 'Purchase Reimbursed by Client?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReturned), label: 'Required Purchase to be Returned?' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
